export const USER_INSIGHTS_ENABLED = "ub-user-insights-enabled";
